// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2069) return "static/chunks/2069.ee54b32c60fe3fee.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1146":"52fe17b186b80b29","2013":"f630aaa715daedd6","2983":"7608ff10cd848630","4466":"af3bc4a3730be7e9","7988":"5b8b7e26929f2e96","9272":"33c66503dfc2e033"}[chunkId] + ".js";
};